const { Core, Events } = Global;

customElements.define('main-nav-mobile', class extends Core {
    elements = {
        $: [['level'], 'toolbar']
    }

    render() {
        if (this._drawer) return;
        this.sub(Events.HEADER_UPDATE, this._handleHeaderUpdate, { global: true, once: true });
        this.sub(Events.HEADER_TOOLBAR_UPDATE, this._handleToolbarUpdate, { global: true, once: true });
        this.$({
            change: this._handleChange,
            click: this._handleTriggerClick,
            keydown: this._handleTriggerKeydown
        });
        this._drawer = this.closest('dialog');
        this._drawerContainer = this._drawer?.closest('modal-container');
        this._onDrawerOpen = (event) => {
            if (event.target !== this._drawerContainer || this._drawer.open) return;
            this.querySelectorAll('input[type="radio"]').forEach(input => { input.checked = false; });
            this._setLevel(0);
            this.scrollLeft = 0;
        };
        this._drawerContainer?.addEventListener('modal-open', this._onDrawerOpen, true);
    }

    destroy() {
        this._drawerContainer?.removeEventListener('modal-open', this._onDrawerOpen, true);
        this._drawer = null;
    }

    _handleTriggerClick(event) {
        const label = event.target.closest('label[role="button"]');
        if (!label || !this.contains(label) || !label.control) return;
        event.preventDefault();
        this._activateTrigger(label.control, false);
    }

    _handleTriggerKeydown(event) {
        const label = event.target.closest('label[role="button"]');
        if (!label || event.target !== label || !label.control || !['Enter', ' '].includes(event.key)) return;
        event.preventDefault();
        if (!event.repeat) this._activateTrigger(label.control, true);
    }

    _activateTrigger(input, moveFocus) {
        if (!input.classList.contains('#main-nav-mobile-level-trigger')) return;
        input.checked = true;
        this._setLevel(+input.value, moveFocus);
    }
    
    _handleChange(e) {
        if (!e.target.classList.contains('#main-nav-mobile-level-trigger')) return;
        this._setLevel(+e.target.value);
    }

    _setLevel(value, moveFocus = false) {
        const activeLevel = this.$('level').find(level => +level.dataset.level === value);
        if (!activeLevel) return;
        this.style.setProperty(
            `--${this.tagName.toLowerCase()}-level`,
            value
        );
        this.$('level').forEach(level => {
            level.inert = level !== activeLevel;
        });
        if (moveFocus) {
            const content = Array.from(activeLevel.children).find(node => node.matches('input:checked'))?.nextElementSibling || activeLevel;
            content.querySelector('label[role="button"], a')?.focus({ preventScroll: true });
        }
    }

    _handleHeaderUpdate(items) {
        this.$('level').map(level => {
            const match = items.find(item => +level.dataset.level === item.level);
            if(match) {
                level.append(...match.children);
            }
        })
        this.querySelectorAll('label').forEach(label => {
            if (label.control?.classList.contains('#main-nav-mobile-level-trigger')) {
                label.setAttribute('role', 'button');
                label.tabIndex = 0;
                if (!label.textContent.trim()) label.setAttribute('aria-label', 'Zurück');
            }
        });
        this.$('level').forEach(level => { level.inert = +level.dataset.level !== 0; });
    }

    _handleToolbarUpdate(items) {
        this.$('toolbar').append(...items);
    }
});
